const styles = (theme) => ({
  buttonRefresh: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
  },
  autocompleteFilter: {
    width: "100%",
    maxWidth: 500,
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },
});

export default styles;
